import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
    AppBar,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core'
import {withRouter} from "react-router-dom"

class ServiceInfoTab extends Component {

    state = {
        actionType: 'view', // view and edit
    }

    render() {
        const {actionType} = this.state
        const {medical} = this.props


        if (actionType === 'view') {

            const data = [
                {title: '職業', message:`${medical.job && medical.job.name} [接任務次序：${medical.level && medical.level.description}]` },
                {title: '科別', message: medical.division && medical.division.total_name},
                {title: '醫療機構', message: `${medical.city && medical.city.name} - ${medical.hospital && medical.hospital.name}`},
                {title: '狀態', message: medical.status && medical.status.name},
                {title: '醫事證號', message: medical.certificate_no},
                {title: '推薦人', message: medical.referrer}
            ];

            return <div>
                    <Card className="w-full mb-16">
                        <AppBar position="static" elevation={0}>
                            <Toolbar className="pl-16 pr-8">
                                <Typography variant="subheading" color="inherit" className="flex-1">
                                    服務設定
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <CardContent className="flex flex-col flex-wrap h-288">
                            {
                                data.map((dt, index) => (
                                    <div className="mb-16" key={`medical_info-${index}`}>
                                        <Typography className="font-bold mb-4 text-15">{dt.title}</Typography>
                                        <Typography>{dt.message ? dt.message : '無資料' }</Typography>
                                    </div>
                                ))
                            }
                        </CardContent>
                    </Card>
                </div>
        } else {
            return (<div/>)
        }

    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}


function mapStateToProps({adminMedicalList: {medical}}) {
    return {
        medical
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServiceInfoTab))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/tabs/ServiceInfoTab.js